import { render, staticRenderFns } from "./DeclineIcon.vue?vue&type=template&id=055746b0&scoped=true&"
import script from "./DeclineIcon.vue?vue&type=script&lang=js&"
export * from "./DeclineIcon.vue?vue&type=script&lang=js&"
import style0 from "./DeclineIcon.vue?vue&type=style&index=0&id=055746b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055746b0",
  null
  
)

export default component.exports